
import Vue from 'vue'
import Vuex from 'vuex'
import { personal } from '@/api/api'
Vue.use(Vuex)
function readStoredUserInfo() {
	try {
		const raw = localStorage.getItem('userinfo')
		if (!raw || raw === 'undefined') return null
		return JSON.parse(raw)
	} catch (e) {
		return null
	}
}
export default new Vuex.Store({
	state: {
		userInfo: readStoredUserInfo()
	},
	mutations: {
		SET_USER_INFO(state, payload) {
			state.userInfo = payload
			if (payload && typeof payload === 'object') {
				try {
					localStorage.setItem('userinfo', JSON.stringify(payload))
				} catch (e) { /* ignore */ }
			}
		},
		CLEAR_USER_INFO(state) {
			state.userInfo = null
			try {
				localStorage.removeItem('userinfo')
			} catch (e) { /* ignore */ }
		}
	},
	actions: {
		/** 拉取个人信息并写入 store，供各页与导航栏实时同步 */
		fetchPersonal({ commit }) {
			return personal({}).then((res) => {
                const inner = res && res.data
                let data = null
                if (inner && typeof inner === 'object' && inner.data !== undefined) {
                    data = inner.data
                } else if (inner !== undefined) {
                    data = inner
                }
				commit('SET_USER_INFO', data)
				return data
			})
		}
	}
})
